<template>
  <DashboardLayout :breadcrumbs="breadcrumbs">
    <h1 class="title is-5">{{ $t('navigation.docflowAgreementsList') }}</h1>
    <div class="container is-fluid">
      <CommonList :data="data"
                  :loading="loading"
                  :total="total"
                  :perPage="perPage"
                  :current-page="page"
                  :sort-field="sortField"
                  :sort-order="sortOrder"
                  @search="loadData"
                  @filter="loadData"
                  @page-change="onPageChange"
                  @sort="onSort"
                  @reset-filters="loadData">
      </CommonList>
    </div>
  </DashboardLayout>
</template>

<script>
  import {mapState, mapGetters} from 'vuex'
  import DashboardLayout from '@/components/DashboardLayout'
  import CommonList from '@/components/CommonList'
  import GovernmentAgencySelect from '@/components/GovernmentAgencySelect'

  export default {
    components: {
      DashboardLayout,
      GovernmentAgencySelect,
      CommonList
    },
    data() {
      return {
        data: [],
        loading: false,
        total: 0,
        page: 1,
        perPage: 15,
        sortField: '',
        sortOrder: 'desc',
        category: 'for_agreement'
      }
    },
    methods: {
      loadData() {
        this.loading = true
        this.$store.dispatch('Docflow/list', {
          category: this.category,
          page: this.page,
          page_size: this.perPage,
          q: this.q,
          ordering: `${this.sortOrder === 'desc' ? '-' : ''}${this.sortField}`,
          ...this.prepareFilter('commonFilters')
        }).then((data) => {
          this.loading = false
          this.total = data.count
          this.data = data.results
        })
      },
      onSort({field, order}) {
        this.sortField = field
        this.sortOrder = order
        this.loadData()
      },
      onPageChange(page) {
        this.page = page
        this.loadData()
      },
      goTo(route) {
        this.$router.push({name: route})
      }
    },
    mounted() {
      this.loadData()
    },
    computed: {
      ...mapState('Docflow', ['list']),
      ...mapGetters('Filters', ['prepareFilter']),
      breadcrumbs() {
        return [
          {name: 'docflow'},
          {name: 'docflowAgreementsList'}
        ]
      }
    }
  }
</script>
